import React, { useMemo, useState } from 'react';
import Header from '../homepage/components/Header';
import Footer from '../homepage/components/Footer';
import Seo from '../../components/Seo';

const ContactPage = () => {
  const emailAddress = 'lmatthews@skylinevfx.com';
  const mailtoHref = useMemo(() => {
    const subject = encodeURIComponent('Skyline VFX enquiry');
    return `mailto:${emailAddress}?subject=${subject}`;
  }, [emailAddress]);
  const gmailComposeHref = useMemo(() => {
    const subject = encodeURIComponent('Skyline VFX enquiry');
    const to = encodeURIComponent(emailAddress);
    return `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}`;
  }, [emailAddress]);

  const [copyStatus, setCopyStatus] = useState('idle'); // idle | copied | error

  const copyEmail = async () => {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(emailAddress);
      } else {
        // Fallback for older browsers / permission issues.
        const textarea = document.createElement('textarea');
        textarea.value = emailAddress;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }

      setCopyStatus('copied');
      window.setTimeout(() => setCopyStatus('idle'), 2000);
    } catch {
      setCopyStatus('error');
      window.setTimeout(() => setCopyStatus('idle'), 2500);
    }
  };

  return (
    <>
      <Seo
        title="Contact - Skyline VFX"
        description="Get in touch for VFX projects, collaborations, or inquiries."
      />
      <div className="min-h-screen text-white">
        <Header />
        <main className="pt-32 pb-20 px-6 lg:px-8">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl lg:text-5xl font-bold mb-4">Get In Touch</h1>
              <p className="text-gray-400 text-lg max-w-2xl mx-auto">
                Available for freelance projects and collaborations.
              </p>
            </div>

            <div className="border border-white/10 bg-white/5 p-6">
              <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                <div>
                  <p className="text-sm text-gray-400">Email</p>
                  <a
                    href={mailtoHref}
                    className="text-lg font-semibold text-white hover:text-[#ffab3e] transition-colors"
                  >
                    {emailAddress}
                  </a>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
                  <a
                    href={gmailComposeHref}
                    target="_blank"
                    rel="noreferrer"
                    className="px-6 py-3 bg-[#ffab3e] hover:bg-[#e69a36] text-black font-semibold rounded-none transition-all shadow-lg shadow-black/40 text-center"
                  >
                    Email me
                  </a>
                  <button
                    type="button"
                    onClick={copyEmail}
                    className="px-6 py-3 bg-white/10 hover:bg-white/15 border border-white/15 text-white font-semibold rounded-none transition-all text-center"
                  >
                    {copyStatus === 'copied' ? 'Copied' : 'Copy email'}
                  </button>
                  <a
                    href="https://www.linkedin.com/in/lee-matthews-1659092a/"
                    target="_blank"
                    rel="noreferrer"
                    className="px-6 py-3 bg-white/10 hover:bg-white/15 border border-white/15 text-white font-semibold rounded-none transition-all text-center"
                  >
                    LinkedIn
                  </a>
                </div>
              </div>

              <div className="mt-4" aria-live="polite">
                <div className="text-sm text-gray-400">
                  If the button doesn’t open for you, use{' '}
                  <a href={mailtoHref} className="text-white hover:text-[#ffab3e] transition-colors">
                    your email app
                  </a>{' '}
                  or copy the address.
                </div>
                {copyStatus === 'error' ? (
                  <div className="text-sm text-red-200">
                    Couldn’t copy automatically—please copy the address manually.
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ContactPage;
